import React, { useEffect, useState } from "react";
import { RotateCw } from "lucide-react";
import { resolveMediaUrl } from "@/lib/imageProxy";
import { normalize360Frames } from "@/lib/viewer360Frames";

/**
 * Kis hover-triggered körforgatás a CarCard-hoz — videóból kivágott kockák.
 */
export function MiniPreview360({ car, active }) {
  const [idx, setIdx] = useState(0);
  const [preloaded, setPreloaded] = useState(false);

  const frames = React.useMemo(() => {
    const all = normalize360Frames(car?.images_360);
    if (all.length < 2) return [];
    const step = Math.max(1, Math.floor(all.length / 4));
    return [0, step, step * 2, step * 3].map((i) => all[Math.min(i, all.length - 1)]);
  }, [car?.images_360]);

  useEffect(() => {
    if (frames.length < 2 || preloaded) return;
    let alive = true;
    let c = 0;
    frames.forEach((src) => {
      const img = new Image();
      img.onload = img.onerror = () => {
        if (!alive) return;
        c += 1;
        if (c >= frames.length) setPreloaded(true);
      };
      img.src = resolveMediaUrl(src);
    });
    return () => { alive = false; };
  }, [frames, preloaded]);

  useEffect(() => {
    if (!active || !preloaded || frames.length < 2) {
      setIdx(0);
      return;
    }
    const iv = setInterval(() => setIdx((i) => (i + 1) % frames.length), 260);
    return () => clearInterval(iv);
  }, [active, preloaded, frames.length]);

  if (frames.length < 2) return null;

  return (
    <div data-testid={`mini-preview-360-${car.id}`} className={`absolute inset-0 pointer-events-none transition-opacity duration-200 ${active && preloaded ? "opacity-100" : "opacity-0"}`}>
      {frames.map((src, i) => (
        <img
          key={i}
          src={resolveMediaUrl(src)}
          alt=""
          referrerPolicy="no-referrer"
          draggable={false}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-150 ${i === idx ? "opacity-100" : "opacity-0"}`}
        />
      ))}
      <div className="absolute bottom-3 right-3 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-black/70 backdrop-blur-md text-[10px] text-white pointer-events-none">
        <RotateCw className="w-2.5 h-2.5 text-electric" strokeWidth={2} /> 360°
      </div>
    </div>
  );
}
